import './types';

/**
 * @param {StatsLeadersState} draft - Draft state.
 * @param {RequestDetails} payload - Action payload.
 */
export const setStatsLeadersRequest = ( draft, payload ) => {
    draft.requests = [ ...draft.requests, payload ];
};